import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import WarningButton from "components/WarningButton";
import SendIcon from "@material-ui/icons/Send";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useState, useEffect } from "react";
import _ from "lodash";

const NewsgateTransformDialog = (props) => {
  const { open, transformId, seasons, handleCancel, handleTransform } = props;
  const [seasonCode, setSeasonCode] = useState(false);
  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleSeasonCodeChange(e) {
    setSeasonCode(e.target.value);
  }

  function handleStartDateChange(e) {
    setStartDate(e.target.value);
  }

  function handleEndDateChange(e) {
    setEndDate(e.target.value);
  }

  async function handleSend() {
    if (loading) return;
    setLoading(true);
    try {
      await handleTransform(transformId, seasonCode, startDate, endDate);
      alert("Sent to Newsgate.");
    } catch (err) {
      alert("ERROR:" + err);
    } finally {
      setLoading(false);
    }
  }

  function cancelHandler() {
    if (loading) return;
    handleCancel();
  }

  useEffect(() => {
    setSeasonCode(_.get(seasons, "data.0.id"));
  }, [seasons]);

  return (
    <Dialog
      open={open}
      onClose={cancelHandler}
      maxWidth="sm"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Send to Newsgate</DialogTitle>
      <DialogContent>
        <DialogContentText>{transformId}</DialogContentText>
        <Select
          labelId="season-code-select-label"
          id="season-code-select"
          disabled={loading}
          value={seasonCode}
          onChange={handleSeasonCodeChange}
        >
          {_.map(!seasons ? [] : seasons.data, (s) => {
            return (
              <MenuItem key={s.id} value={s.id}>
                {s.label}
              </MenuItem>
            );
          })}
        </Select>
        <div>
          <TextField
            id="startDate"
            type="date"
            onChange={handleStartDateChange}
            disabled={loading}
          />
        </div>
        <div>
          <TextField
            id="endDate"
            type="date"
            onChange={handleEndDateChange}
            disabled={loading}
          />
        </div>
        <DialogActions>
          <Button onClick={cancelHandler} color="primary" disabled={loading}>
            Cancel
          </Button>
          <WarningButton label="Send" onClick={handleSend} disabled={loading}>
            <SendIcon />
          </WarningButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default NewsgateTransformDialog;
